import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AlertController } from '@ionic/angular';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';

import { StorageService } from '../../../services/storage.service';


@Component({
  selector: 'app-table',
  templateUrl: './table.page.html',
  styleUrls: ['./table.page.scss'],
})
export class TablePage implements OnInit {

  constructor(
    private alertCtrl: AlertController,
    private barcodeScanner: BarcodeScanner,
    private router: Router,
    private storage: StorageService,
  ) { }

  ngOnInit() {
  }

  aionViewDidEnter() {
    try {
      this.barcodeScanner.scan({
        showTorchButton: true
      }).then(result => {
        // this.alertCtrl.create({
        //   header: 'result',
        //   message: JSON.stringify(result)
        // }).then(alert => alert.present())
        this.storage.save('cnpj', result)
        this.router.navigate([result])
      }).catch(error => {
        this.alertCtrl.create({
          header: 'Error scanner',
          message: JSON.stringify(error)
        }).then(alert => alert.present())
      })
    } catch(e) {
      this.alertCtrl.create({
        message: 'erro' + e
      }).then(alert => alert.present())
    }
  }

  testarRota() {
    this.router.navigate(['32759021000181'])
  }
}
